import { Button } from "@mui/material"
import removeImage from "@/assets/img/reservations/icons/remove.svg"
import { plural, trans } from "@/_providers/Translation"

export default function ServicingAction({
  action,
  index,
  onUpdateField,
  onRemove,
  validations,
}) {
  const handleInputChange = (e) => {
    const { name, value } = e.target
    // Extract field name from servicing_actions[index][field_name] format
    const fieldName = name.match(/\[([^\]]+)\]$/)?.[1] || name
    onUpdateField(index, fieldName, value)
  }

  return (
    <div className="device-container">
      <div className="head">
        {`${trans('labels.servicingActivity')} ${index + 1}`}
        {onRemove && (
          <Button
            onClick={(e) => {
              e.stopPropagation()
              onRemove(index)
            }}
          >
            <img src={removeImage} alt="Remove" />
          </Button>
        )}
      </div>
      <div className="body">
        <div className="row">
          <div className="col">
            <label>{trans("labels.name")}</label>
            <input
              type="text"
              name={`servicing_actions[${index}][action_name]`}
              value={action?.action_name || ""}
              onChange={handleInputChange}
              className={
                validations && validations[`servicing_actions.${index}.action_name`]
                  ? "validate"
                  : ""
              }
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col"
            style={{
              maxWidth: "150px",
            }}
          >
            <label>{trans("labels.price")}</label>
            <input
              type="number"
              min="0"
              step="0.01"
              name={`servicing_actions[${index}][price]`}
              value={action?.price || ""}
              onChange={handleInputChange}
              className={
                validations && validations[`servicing_actions.${index}.price`]
                  ? "validate"
                  : ""
              }
            />
          </div>
          <div className="col">
            <div className="period-select">
              <label>{trans("labels.period")}</label>
              <div className="select-holder">
                <input
                  type="number"
                  min="0"
                  step="1"
                  name={`servicing_actions[${index}][period_value]`}
                  value={action?.period_value || ""}
                  onChange={handleInputChange}
                  className={
                    validations && validations[`servicing_actions.${index}.period_value`]
                      ? "validate"
                      : ""
                  }
                  style={{
                    maxWidth: "100px",
                  }}
                />
                <select
                  name={`servicing_actions[${index}][period_unit]`}
                  value={action?.period_unit || 1}
                  onChange={handleInputChange}
                  className={
                    validations && validations[`servicing_actions.${index}.period_unit`]
                      ? "validate"
                      : ""
                  }
                >
                  <option value={1}>{plural("plural_periods.day", action?.period || 1)}</option>
                  <option value={2}>{plural("plural_periods.week", action?.period || 1)}</option>
                  <option value={3}>{plural("plural_periods.month", action?.period || 1)}</option>
                  <option value={4}>{plural("plural_periods.year", action?.period || 1)}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        {action?.id ? (
          <input
            type="hidden"
            name={`servicing_actions[${index}][id]`}
            value={action.id}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}
